import { TEmojiId } from './room.types';

export interface IPeerInfo {
  join_data_time: string;
  peer_uuid: string;
  peer_id: string;
  peer_name: string;
  peer_token: boolean;
  peer_presenter: boolean;
  peer_audio: boolean;
  peer_audio_volume: number;
  peer_video: boolean;
  peer_screen: boolean;
  peer_recording: boolean;
  peer_video_privacy: boolean;
  peer_hand: boolean;
  peer_stream_uid?: number;
  peer_screen_stream_id?: number;
  is_desktop_device: boolean;
  is_mobile_device: boolean;
  is_tablet_device: boolean;
  is_ipad_pro_device: boolean;
  os_name: string;
  os_version: string;
  browser_name: string;
  browser_version: number | string;
  user_agent: string;
  user_type?: TUserType;
  peer_image?: string;
  hue_color?: number;
}

export interface IPeer {
  id: string;
  peer_info: IPeerInfo;
  peer_uuid: string;
  peer_name: string;
  peer_presenter?: boolean;
  peer_audio?: boolean;
  peer_video?: boolean;
  stream_uid?: number;
  peer_audio_volume?: number;
  peer_video_privacy?: boolean;
  peer_recording?: boolean;
  peer_hand?: boolean;
  peer_emoji?: TEmojiId;
  transports?: any; //To be e changed later
  consumers?: any; //To be e changed later
  producers?: any; //To be e changed later

  record_id?: string;
  permissions?: TPeerPermission[];
  state?: { magic_pen_hidden?: boolean };
}

export enum EUserType {
  HOST = 'HOST',
  CO_HOST = 'CO_HOST',
  SPEAKER = 'SPEAKER',
  ATTENDEE = 'ATTENDEE',
}

export type TUserType = EUserType;

export type TUserTypeWithoutHost = Exclude<TUserType, EUserType.HOST>;

export type TWebinarInviteesType = Exclude<TUserTypeWithoutHost, EUserType.ATTENDEE>;

export type TPeerMap = Map<string, IPeer>;

export type TPeerActionTypes = 'audio' | 'video' | 'screen' | 'hand' | 'screenType' | 'recording' | 'speechToText';

// Peer permission types
export enum EPeerPermission {
  MAGIC_PEN_ALLOW_ANNOTATE = 'MAGIC_PEN_ALLOW_ANNOTATE',
  ACTING_HOST = 'ACTING_HOST',
}

export type TPeerPermission = EPeerPermission;

// Peer permission event types
export enum EPeerPermissionEventType {
  UPDATE_PEER_PERMISSION = 'UPDATE_PEER_PERMISSION',
}

export type TPeerPermissionEventType = EPeerPermissionEventType;

export interface IUpdatePeerPermissionEvent {
  eventType: TPeerPermissionEventType;
  eventSource: string;
  sourceName: string;
  permission: TPeerPermission;
  isGranted: boolean;
  message: string;
}
